var dd = require('react-dd');
var _ = require('lodash');

module.exports = {
	component: dd.createClass({
		render: function(){
			var field = this.props.field;
			var value = this.props.value;
			return dd.p({className: 'form-control-static'},
				field.options && _.has(field.options, value) ? field.options[value] : value
			);
		}
	}),
	validate: function(){
		return true;
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/Static.js
// module id = 201
// module chunks = 0 1 2 3 4